import SubjectsIndex from '@/views/subjects/SubjectsIndex.vue';
import SubjectAdd from '@/views/subjects/AddSubject.vue';
import SubjectEdit from '@/views/subjects/EditSubject.vue';
import EditTopic from '@/views/topics/EditTopic.vue';
import ClassSubjectTeachers from '@/views/subjects/ClassSubjectTeachers.vue';
import AddClassSubjectTeacher from '@/views/subjects/AddClassSubjectTeacher.vue';
import SubjectGradeSheet from '@/views/grade-sheets/SubjectGradeSheet.vue';
import GradeSheetView from '@/views/grade-sheets/GradeSheetView.vue';
import { t } from '@/i18n';

export default [
  {
    path: '/subjects',
    name: 'subjects.index',
    component: SubjectsIndex,
    meta: { title: 'subjects.indexTitle', requiredPerm: 'subjects.display' },
    children: [
      {
        path: '/subjects/add',
        name: 'subjects.create',
        component: SubjectAdd,
        meta: { title: 'subjects.addTitle', requiredPerm: 'subjects.create' }
      },
      {
        path: '/subjects/:id/edit',
        name: 'subjects.edit',
        component: SubjectEdit,
        meta: { title: 'subjects.editTitle', requiredPerm: 'subjects.update' }
      },
      {
        path: ':subjectId/grade-sheets',
        name: 'subject-grade-sheets',
        component: SubjectGradeSheet,
        props: true,
        meta: {
          title: 'subjects.gradeSheetsTitle',
          requiresAuth: true,
          requiredPerm: 'grade_sheets.display',
          breadcrumb: () => t('subjects.gradeSheetsTitle')
        },
        children: [
          {
            path: ':id',
            name: 'subject-grade-sheets.view',
            component: GradeSheetView,
            props: (route) => ({ id: route.params.id }),
            meta: {
              title: 'gradeSheets.viewTitle',
              requiresAuth: true,
              requiredPerm: 'subject_grade_sheets.display',
              breadcrumb: (route) =>
                route.query.readonly === '1'
                  ? `${t('gradeSheets.viewTitle')} (${t('gradeSheets.readonly')})`
                  : t('gradeSheets.viewTitle')
            },
          },
        ],
      },
      {
        path: '/subjects/:id/topics',
        name: 'subjects.topics',
        component: () => import('@/views/subjects/TopicList.vue'),
        meta: { title: 'subjects.topicsTitle', requiredPerm: 'topics.display' },
        children: [
          {
            path: '/subjects/:id/topics/create',
            name: 'subjects.topics.create',
            component: () => import('@/views/topics/AddTopicToSubject.vue'),
            meta: { 
              title: 'subjects.addTopicTitle',
              requiresAuth: true,
              requiredPerm: 'topics.create',
            }
          },
          {
            path: 'topics/:id/edit',
            name: 'topics.edit',
            component: EditTopic,
            props: true,
            meta: { 
              title: 'subjects.editTopicTitle',
              requiresAuth: true,
              requiredPerm: 'topics.update',
            },
          }
        ]
      },
      {
        path: '/classes/:classId/subjects/:subjectId/teachers',
        name: 'class-subject-teachers',
        component: ClassSubjectTeachers,
        meta: { 
          title: 'subjects.teachersTitle',
          requiresAuth: true,
          requiredPerm: 'class_group_teachers.display',
        },
        children: [
          {
            path: '/classes/:classId/subjects/:subjectId/teachers/add',
            name: 'add-class-subject-teacher',
            component: AddClassSubjectTeacher,
            meta: { 
              title: 'subjects.addTeacherTitle',
              requiresAuth: true,
              requiredPerm: 'class_group_teachers.create',
            }
          }
        ]
      }
    ]
  }
];
